import { Reveal } from "./Reveal";

const OUTCOMES = [
  "Identify the root of fear",
  "Regulate and innerstand your nervous system",
  "Develop body awareness and emotional resilience",
  "Integrate spiritual and energetic experiences",
  "Reconnect with your Soul's Purpose",
  "Anchor into greater clarity and purposeful direction",
  "Create sustainable practices for long-term transformation",
];

export const Outcomes = () => (
  <section
    data-testid="outcomes-section"
    className="px-6 md:px-12 py-28 md:py-40 lg:py-48"
  >
    <div className="max-w-6xl mx-auto grid md:grid-cols-12 gap-12">
      <div className="md:col-span-4">
        <Reveal>
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-amethyst font-medium md:sticky md:top-32">
            This journey supports you to
          </p>
        </Reveal>
      </div>
      <div className="md:col-span-8">
        {OUTCOMES.map((o, i) => (
          <Reveal key={o} delay={0.05 * i} y={28}>
            <div
              data-testid={`outcome-item-${i + 1}`}
              className="flex items-baseline gap-6 py-5 md:py-6 border-t border-soil/15 group"
            >
              <span className="text-gold text-lg leading-none">✦</span>
              <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-soil tracking-tight leading-tight group-hover:text-amethyst group-hover:translate-x-2 transition-all duration-500">
                {o}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
